/**
 * Constants for wiki content formats and editor modes.
 * Use these instead of raw strings throughout wiki components.
 */

/** Content format: the MIME type indicating how the wiki page content is stored */
export type WikiContentFormat = 'text/html' | 'text/markdown';

/** Editor mode: which editing interface is active */
export type WikiEditorMode = 'markdown' | 'wysiwyg';

/** Preview style for the markdown editor */
export type WikiPreviewStyle = 'tab' | 'vertical';

export const WikiConstants = {
    ContentFormat: {
        HTML: 'text/html' as WikiContentFormat,
        MARKDOWN: 'text/markdown' as WikiContentFormat,
    },
    EditorMode: {
        MARKDOWN: 'markdown' as WikiEditorMode,
        WYSIWYG: 'wysiwyg' as WikiEditorMode,
    },
    PreviewStyle: {
        TAB: 'tab' as WikiPreviewStyle,
        VERTICAL: 'vertical' as WikiPreviewStyle,
    },
};
